<ng-container *ngIf="loading">
  <div
    class="w-full -mt-14 -mb-20 flex justify-center lg:!my-0 pl-4"
    (mouseleave)="deactivateAnimation()"
  >
    <div
      class="flex my-4 mx-4 lg:mx-8 w-full bg-banner rounded-3xl h-32 max-w-[1314px] flex-col-reverse lg:flex-row overflow-hidden"
    >

      <!-- =====[سمت راست]====== -->
      <div
        class="hidden lg:flex lg:basis-1/3 xl:basis-1/4 2xl:basis-1/3 xl:pr-6 2xl:pr-10 items-center justify-center my-8 lg:my-0"
      >
        <p
          class="text-white font-bold xl:text-lg w-full text-center leading-relaxed"
        >
          راه موفقیت در بازارهای مالی همینجاست
          <br>

          <span class="mx-1 text-[#FFEE00] font-black banner-lines">
            <span>مشاورهٔ سرمایه‌گذاری | رباتِ معامله‌گر</span>
            <span>ربات طلا | ربات فارکس | ربات پراپ</span>
          </span>
        </p>
      </div>

      <!-- =====[ستون وسط]====== -->
      <div
        class="flex flex-col lg:basis-2/4 2xl:basis-2/4 justify-center items-center m-7 lg:m-0"
      >

        <!-- =====[متن قبل از باز شدن فرم]====== -->
        <ng-container *ngIf="!animation">

          <p
            class="text-white font-black text-center text-xl lg:text-2xl -mb-3"
            [ngClass]="
              animation == false
                ? 'animation-move-right-reverse'
                : 'animation-move-right'
            "
          >
            فــــــرمٌ پــــــر کن، جواب سوالاتتو بگیر
          </p>

          <div
            class="flex -mb-4 lg:-mb-0 mt-6"
            (mouseenter)="activeAnimation()"
            (click)="activeAnimation()"
          >
            <span
              class="flex box-c"
              [ngClass]="
                animation == false
                  ? 'animation-move-right-reverse'
                  : 'animation-move-right'
              "
            >
              <p class="flex text-white font-bold lg:text-xl">
                مشاوره
                <span class="mx-1 text-[#FFEE00] font-black">
                  رایگان
                </span>
              </p>

              <div class="w-6 2xl:w-12 aspect-square">
                <app-lottie [config]="lottieConfig2" />
              </div>
            </span>
          </div>

        </ng-container>


        <!-- =====[فرم / OTP]====== -->
        <ng-container *ngIf="animation">

          <form
            class="flex flex-col items-center justify-center form-wrapper -mb-2"
            [formGroup]="form"
            (ngSubmit)="consultationServices()"
            [ngClass]="
              animation
                ? 'animation-move-right-reverse'
                : 'animation-move-right'
            "
          >

            <!-- ============================= -->
            <!-- مرحله اول: اطلاعات کاربر -->
            <!-- ============================= -->
            <ng-container *ngIf="!otpStep">

              <div class="form-grid w-full lg:w-[85%] md:w-[70%]">

                <!-- نام -->
                <div class="input-cell">
                  <input
                    id="firstName"
                    formControlName="firstName"
                    placeholder="نام"
                    class="input-small"
                    autocomplete="given-name"
                  />
                </div>

                <!-- نام خانوادگی -->
                <div class="input-cell">
                  <input
                    id="lastName"
                    formControlName="lastName"
                    placeholder="نام خانوادگی"
                    class="input-small"
                    autocomplete="family-name"
                  />
                </div>

                <!-- شماره تماس -->
                <div class="input-cell">
                  <input
                    id="phoneNumber"
                    formControlName="phoneNumber"
                    placeholder="شماره تماس"
                    class="input-small"
                    inputmode="numeric"
                    autocomplete="tel"
                  />
                </div>

                <!-- دکمه ثبت -->
                <div class="input-cell flex items-center justify-center">
                  <button
                    type="submit"
                    aria-label="ارسال کد تایید"
                    class="btn-form btn-full"
                    [disabled]="otpSending"
                  >
                    <p class="text-[#061fb8] font-bold text-sm">
                      {{ otpSending ? 'در حال ارسال...' : 'ارسال کد تایید' }}
                    </p>
                  </button>
                </div>

              </div>

            </ng-container>


            <!-- ============================= -->
            <!-- مرحله دوم: تایید شماره موبایل -->
            <!-- ============================= -->
<!-- ============================= -->
<!-- مرحله دوم: تایید شماره موبایل -->
<!-- ============================= -->
<ng-container *ngIf="otpStep">

  <div class="banner-otp-wrapper">

    <div class="banner-otp-title">
      <p class="text-white font-bold text-center">
        کد تایید به شماره
        <span class="banner-otp-phone text-[#f3f1d8]">
          {{ _phoneNumber }}
        </span>
        ارسال شد
      </p>
    </div>


    <!-- ===== کد تایید + دکمه تایید ===== -->
    <div class="banner-otp-input-actions">

      <div class="banner-otp-input-wrapper">
        <input
          id="bannerOtpCode"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="4"
          class="banner-otp-input"
          placeholder="----"
          [value]="otpCode"
          (input)="fillOtpValue($any($event.target).value)"
          aria-label="کد تایید"
        />
      </div>
    
      <button
        type="submit"
        class="btn-form banner-otp-submit"
        [disabled]="otpSending || otpCode.length !== 4"
      >
        <p class="text-[#061fb8] font-bold text-sm">
          {{ otpSending ? 'در حال بررسی...' : 'تایید کد' }}
        </p>
      </button>
    
      <!-- ===== شمارنده ارسال مجدد ===== -->
      <div
        class="banner-otp-cooldown"
        *ngIf="otpCooldown > 0"
      >
        <span class="banner-otp-cooldown-icon">↻</span>
        <span>ارسال مجدد کد</span>
        <strong>{{ otpCooldown }}</strong>
        <span>ثانیه دیگر</span>
      </div>
    
      <!-- ===== ارسال مجدد بعد از پایان شمارنده ===== -->
      <button
        *ngIf="otpCooldown === 0"
        type="button"
        class="banner-otp-resend"
        [disabled]="otpSending"
        (click)="sendConsultationOTP()"
      >
        {{ otpSending ? 'در حال ارسال...' : 'ارسال مجدد کد تایید' }}
      </button>
    
    </div>


    <!-- ===== تغییر شماره ===== -->
    <button
      type="button"
      class="banner-otp-back"
      [disabled]="otpSending"
      (click)="backToConsultationForm()"
    >
      تغییر شماره / بازگشت
    </button>

  </div>

</ng-container>
          </form>

        </ng-container>

      </div>


      <!-- =====[سمت چپ]====== -->
      <div
        class="lg:flex lg:basis-1/4 xl:basis-1/5 2xl:basis-1/4 items-center justify-center hidden"
      >
        <div class="aspect-square w-36">
          <app-lottie [config]="lottieConfig" />
        </div>
      </div>

    </div>
  </div>
</ng-container>